import React, {useContext} from "react"
import {useTranslation} from "react-i18next";
import ChatControlButton, {ChatControlButtonProps} from "../general/controls/ChatControlButton";
import SVGToggleIcon from "../icons/SVGToggleIcon";
import SVGIcon from "../icons/SVGIcon";
import MediaContext from "../../context/MediaContext";

type ButtonList = ChatControlButtonProps[]

export default () => {
    const {
        videoEnabled, setVideoEnabled,
        audioEnabled, setAudioEnabled,
        cameraUnavailable, micUnavailable, micOsMuted,
        cameraWarningKey, micWarningKey,
    } = useContext(MediaContext)

    const toggleVideo = () => setVideoEnabled(!videoEnabled)
    const toggleMute = () => setAudioEnabled(!audioEnabled)

    const {t} = useTranslation()

    const buttons: ButtonList = []

    // RISKS.md/P2.41: both toggles take the green room's `blocked` prop so the two rooms behave
    // identically — an operator decision that reversed P2.28, which had deliberately left it off.
    buttons.push({
        onClick: () => toggleVideo(),
        active: videoEnabled,
        title: t('videoControl.camera.enable'),
        activeTitle: t('videoControl.camera.disable'),
        hasWarning: cameraUnavailable,
        warningTooltip: t(cameraWarningKey),
        blocked: cameraUnavailable,
        icon: new SVGToggleIcon('video-off', 'video')
    })

    buttons.push({
        onClick: () => toggleMute(),
        active: audioEnabled,
        title: t('videoControl.mic.enable'),
        activeTitle: t('videoControl.mic.disable'),
        hasWarning: micUnavailable || micOsMuted,
        warningTooltip: t(micWarningKey),
        // Keyed on `micUnavailable` ALONE — an OS-muted microphone is not blocked: it still works,
        // so the user must keep their own mute (RISKS.md/P2.41).
        blocked: micUnavailable,
        icon: new SVGToggleIcon('microphone-off', 'microphone')
    })

    buttons.push({
        onClick: () => {},
        active: false,
        title: t('videoControl.pushToTalk'),
        icon: new SVGIcon('speaker')
    })

    return (
        <>
            { buttons.map((props, i) => (
                <ChatControlButton key={i} {...props}/>)
            )}
        </>
    )
}
